<div
  class="container {{ variant() }}"
  [class.f-body-s]="variant() === 'label'"
  [class.disabled]="disabled()"
  [class.alignRight]="alignRight()"
>
  <div class="content">
    <div class="wrapper">
      <p
        class="label"
        [onyxTooltip]="label()"
        [onyxTooltipDisabled]="
          overflowHelper.hasNoOverflow.bind(overflowHelper, labelTextElement)
        "
        #labelTextElement
      >
        {{ label() | translate }}
      </p>

      @if (!disabled() && required()) {
        <span class="required">*</span>
      }
    </div>

    @if (translatedHint(); as hint) {
      <onyx-icon
        name="tooltip-filled"
        [size]="12"
        [onyxTooltip]="hint"
        onyxTooltipTextAlign="left"
      ></onyx-icon>
    }
  </div>

  <ng-content select="[content]"></ng-content>

  @if (link(); as link) {
    <onyx-link
      class="link"
      [color]="link.color ?? 'gray'"
      [font]="link.font ?? 'f-body-xs f-medium'"
      (click)="link.callback?.(); $event.stopPropagation()"
    >
      {{ link.label | translate }}
    </onyx-link>
  }
</div>
